import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import SummaryItem from './SummaryItem';

// Components

import SubHeader from '../../../headers/SubHeader';
import PageHeader from '../../../headers/PageHeader';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { normalizeAddress } from '@utils/normalize/normalizeAddress';
import { helperFunctions } from '@utils/tools/helperFunctions';

// Constants

import { GENDER_TYPES } from '@constants/ssap/miscellaneous/miscellaneous';
import { PAGES } from '@constants/ssap/flows/pagesTypes';


const FamilyAndHouseholdSummary_MN = props => {

    const {
        householdMembers,
        buttonContainer: ButtonContainer
    } = props;

    const moreAboutHousehold = () => householdMembers.map((member, i) => {
        const {
            name,
            americanIndianAlaskaNative : {
                memberOfFederallyRecognizedTribeIndicator
            }
        } = member;

        return (
            <div
                key={`${member.name.firstName}_${member.name.lastName}_more_${i}`}
                className='grid row'
            >
                <SummaryItem
                    category='common.non_internationalized_text'
                    replacements={{
                        text: normalizeNameOfPerson(name)
                    }}
                    value= {memberOfFederallyRecognizedTribeIndicator}
                />
            </div>
        );
    });

    const householdMembersContent = () => householdMembers.map((member, i) => {
        const {
            applyingForCoverageIndicator,
            name,
            gender,
            socialSecurityCard: {
                socialSecurityNumber,
                reasonableExplanationForNoSSN
            },
            householdContact: {
                homeAddress,
                mailingAddress,
                mailingAddressSameAsHomeAddressIndicator
            }
        } = member;

        return (
            <div key={`${member.name.firstName}_${member.name.lastName}_hh_${i}`}>
                <div className="summary__header">
                    <SubHeader
                        text='ssap.subheader.non_internationalized_text'
                        textReplacements={{
                            text: (
                                <FormattedMessage
                                    id='ssap.subheader.person_name_primary_contact'
                                    values={{
                                        personName: normalizeNameOfPerson(name),
                                        primaryContact: <FormattedMessage id={i === 0 ? 'common.primary_contact' : 'common.no_text'}/>
                                    }}
                                />
                            )
                        }}
                        headerClassName={'gi-heading-alt'}
                        additionalElement={(
                            <ButtonContainer
                                type="editButton_secondary"
                                args={[i, PAGES.PERSONAL_INFORMATION_PAGE]}
                            />
                        )}
                        additionalElementClassName={'header-btn'}
                    />
                </div>
                <div className="grid-row">
                    <SummaryItem
                        textCode='common.applying_for_coverage'
                        value={applyingForCoverageIndicator}
                    />

                    <SummaryItem
                        textCode='common.gender'
                        value='common.non_internationalized_text'
                        replacements={{
                            text: gender.toLowerCase() === GENDER_TYPES.FEMALE ?
                                <FormattedMessage id='common.female'/> :
                                <FormattedMessage id='common.male'/>

                        }}
                    />

                    <SummaryItem
                        textCode='common.ssn'
                        value='common.non_internationalized_text'
                        replacements={{
                            text: helperFunctions.getValueForSSN(socialSecurityNumber, reasonableExplanationForNoSSN)
                        }}
                    />

                    <SummaryItem
                        textCode="common.home_address"
                        value='common.non_internationalized_text'
                        replacements={{
                            text: normalizeAddress(homeAddress)
                        }}
                    />

                    {
                        i === 0 && !mailingAddressSameAsHomeAddressIndicator &&

                        <SummaryItem
                            textCode="common.mailing_address"
                            value='common.non_internationalized_text'
                            replacements={{
                                text: normalizeAddress(mailingAddress)
                            }}
                        />
                    }

                    {
                        i === 0 && mailingAddressSameAsHomeAddressIndicator &&

                        <SummaryItem
                            textCode="common.mailing_address"
                            value='common.same_as_home'
                        />
                    }
                </div>
            </div>
        );
    });

    return (
        <Fragment>
            <div className='summary__block margin-b-20'>
                <div className="grid-row bordered">
                    { householdMembersContent() }
                </div>
            </div>

            <PageHeader
                text='common.more_about_household'
                headerClassName={'gi-heading-alt'}
            />

            <div className='summary__block margin-b-20'>
                <div className="bordered">
                    <SubHeader
                        text='common.member_of_tribe'
                        headerClassName={'gi-heading-alt'}
                    />
                    { moreAboutHousehold() }
                </div>
            </div>
        </Fragment>
    );
};

export default FamilyAndHouseholdSummary_MN;
